import { EventEmitter } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ConfigService } from "./config.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class EventCargaMasivaService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Authorization: sessionStorage.getItem("batoken"),
                User: sessionStorage.getItem("userid"),
            }),
        };
        this.invokeFirstComponentFunction = new EventEmitter();
        this.headers = new HttpHeaders();
    }
    onCargaMasivaComponentButtonClick() {
        this.invokeFirstComponentFunction.emit();
    }
    insertCargaMasiva(capacitacion, userId, estado, empresa, rolId) {
        let listaCapacitaciones = [];
        for (let caps of capacitacion) {
            let fecha = String(caps[9]).split("-");
            let cap = new Map();
            cap.set("nombreCapacitacion", caps[1]);
            cap.set("zona", caps[2]);
            cap.set("foco", caps[3]);
            cap.set("categoria", caps[4]);
            cap.set("enfoque", caps[5]);
            cap.set("observacion", caps[6]);
            cap.set("ejecutor", caps[7]);
            cap.set("relator", caps[8]);
            cap.set("fecha", caps[9]);
            cap.set("cantidadAsistentes", caps[10]);
            cap.set("duracionEstimada", caps[11]);
            cap.set("userId", userId);
            cap.set("estadoId", estado);
            cap.set("planCapacitacion", rolId === "1" || rolId === "2" ? caps[12] + "-" + caps[2] + "-" + fecha[2] : empresa + "-" + caps[2] + "-" + fecha[2]);
            cap.set("contratista", (rolId === "1" || rolId === "2" ? caps[12] : empresa));
            cap.set("tipoCreacion", (rolId === "1" || rolId === "2" ? "administrador" : "contratista"));
            cap.set("proceso", (rolId === "1" || rolId === "2" ? caps[13] : caps[12]));
            let obj = Array.from(cap).reduce((obj, [key, value]) => Object.assign(obj, { [key]: value }), {});
            listaCapacitaciones.push(obj);
        }
        let capacitaciones = JSON.stringify(listaCapacitaciones);
        console.log(capacitaciones);
        return this.http
            .post(`${this.configService.API_URL}/capacitaciones/carga-masiva`, capacitaciones, Object.assign({}, this.jsonContent, { responseType: "text" }))
            .toPromise();
    }
}
EventCargaMasivaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventCargaMasivaService_Factory() { return new EventCargaMasivaService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: EventCargaMasivaService, providedIn: "root" });
